import { history } from "../_helpers";

export const dataJobRunTrackerServices = {
  getAllJobRunTracker,
  getJobRunTrackerById,
  getDataQualityChecks,
  getDataQualityChecksFilter,
  applyDataQualityChecksFilters,
  applyJobRunTrackerFilters
};

function getAllJobRunTracker(workflowId, offset = 0, limit = 10) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/jobRunTracker/${workflowId}/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getJobRunTrackerById(workflowId, jobRunTrackerId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/jobRunTracker/${jobRunTrackerId}`,
    requestOptions
  ).then(handleResponse);
}

function getDataQualityChecks(offset, limit, jobRunTrackerId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/jobRunTracker/${jobRunTrackerId}/dataQuality?offset=${offset}&limit=${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getDataQualityChecksFilter(jobRunTrackerId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/dataQuality/filters?jobRunTrackerId=${jobRunTrackerId}`,
    requestOptions
  ).then(handleResponse);
}

function applyDataQualityChecksFilters(
  qualityName,
  columnName,
  offset,
  limit,
  jobRunTrackerId
) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify({
      qualityName,
      columnName,
      offset,
      limit,
      jobRunTrackerId,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/dataQuality/filters?jobRunTrackerId=${jobRunTrackerId}`,
    requestOptions
  ).then(handleResponse);
}

function applyJobRunTrackerFilters(workflowId ,status, startDate, endDate, offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify({
      status,
      startDate,
      endDate,
      offset,
      limit,
      workflowId
    }),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/jobRunTracker/filters?workflowId=${workflowId}&offset=${offset}&limit=${limit}`,
    requestOptions
  ).then(handleResponse);
}

// helper functions

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        // redirecting to signin page
        history.push("/auth/signin");
        // removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
